export const meKeys = {
  me: ['me'] as const,
  passengers: ['me', 'passengers'] as const,
  profile: ['me', 'profile'] as const,
}
